/**
 * Shared URL validation (admin-frontend UX tier).
 *
 * MIRROR of backend/src/shared/validateUrl.ts — keep the rule identical in both
 * tiers. Behaviour matches the inline URL_RE it replaces (/^https?:\/\/.+/i):
 * must start with http:// or https:// and have at least one more character.
 * Deliberately permissive — gates "a custom social link must be a full URL".
 *
 * The value is NEVER rewritten/normalised — validate the raw string as typed.
 */

export interface UrlValidationResult {
  ok: boolean
  error?: string
}

/** User-facing error. */
export const URL_ERROR = 'Enter a full URL (https://…)'

// Identical to the inline URL_RE this replaces.
export const URL_RE = /^https?:\/\/.+/i

/**
 * Validate a URL string. Empty is INVALID here; callers treat URL fields as
 * optional by skipping validation when the field is blank.
 */
export function validateUrl(raw: string): UrlValidationResult {
  const s = String(raw ?? '').trim()
  if (!s) return { ok: false, error: URL_ERROR }
  if (!URL_RE.test(s)) return { ok: false, error: URL_ERROR }
  return { ok: true }
}

export default validateUrl
